'use client';

import { useEffect, useRef } from 'react';
import Player, { Options } from '@vimeo/player';
import { asText, isFilled, RichTextField } from '@prismicio/client';

type VimeoContainerProps = {
  caption?: RichTextField;
  vimeoId: number | undefined;
};

export const VimeoContainer = ({ vimeoId, caption }: VimeoContainerProps) => {
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (playerRef.current === null) {
      return;
    }

    const options: Options = {
      loop: false,
      id: vimeoId,
      autoplay: false,
    };

    new Player(playerRef.current, options);
  }, []);

  return (
    <figure>
      <div className="feature-video" ref={playerRef}></div>

      {isFilled.richText(caption) && <figcaption>{asText(caption)}</figcaption>}
    </figure>
  );
};
